import React from 'react'
import { MdClose } from 'react-icons/md'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import './styles.scss'

const bc = 'editing-form'

const EditingForm = ({
  t,
  handleSubmit,
  pristine,
  submitting,
  handleClosePopover,
  title,
  onRemove,
  isShowDeleteButton,
  children,
  invalid,
}) => (
  <form onSubmit={handleSubmit} className={bc}>
    <MdClose
      style={{
        position: 'absolute',
        right: '16px',
        cursor: 'pointer',
      }}
      onClick={handleClosePopover}
    />
    <span className={`${bc}__title`}>{title}</span>
    {children}
    <Button type="submit" primary sm className={`${bc}__button`} disabled={pristine || submitting || invalid}>
      {t('Save')}
    </Button>
    {isShowDeleteButton && (
      <Button danger sm className={`${bc}__button`} onClick={onRemove} style={{ marginTop: '8px' }}>
        {t('Delete')}
      </Button>
    )}
  </form>
)

EditingForm.defaultProps = {
  isShowDeleteButton: false,
}

EditingForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  invalid: PropTypes.bool,
  handleClosePopover: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  isShowDeleteButton: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default reduxForm()(withTranslation()(EditingForm))
